import React from "react";
import type { ModeRendererProps } from "./types";

export function VasarelyPenguinMode({ Copy }: ModeRendererProps) {
  return (
    <g>
      <rect width={794} height={1123} fill="#eaf6ff" />
      <ellipse cx={397} cy={560} rx={140} ry={220} fill="#000" />
      <ellipse cx={397} cy={560} rx={90} ry={160} fill="#fff" />
      <g className="mode-copy" transform="translate(48,840)" fill="#001"><text x={0} y={0} fontSize={18}>{Copy?.title}</text></g>
    </g>
  );
}

export default VasarelyPenguinMode;
